import { Injectable } from '@angular/core';
import { IChangePasswordService } from './changePassword.service.interface';
import { ChangePasswordModel } from '../entities/changePasswordModel';
import { SessionModel } from '../../../session/entities/sessionModel';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../appState/app.state';
import { AppState } from '../../../appState/appStateStore.module';
import { PasswordChangedModel } from '../entities/passwordChangedModel';

@Injectable()
export class ChangePasswordMockService implements IChangePasswordService {

      constructor(private store: Store<AppState>) { }

      change(changePassword: ChangePasswordModel): Promise<PasswordChangedModel> {

        let session: SessionModel = null;

        this.store.take(1).subscribe(s => session = s.app.session);

        if (!session.user || !session.token) {
          return Promise.reject('Keine gültige Anmeldung!');
        }

        return Promise.resolve(<PasswordChangedModel>{changed:true, token:session.token});
      }
}


// WEBPACK FOOTER //
// ./src/app/account/changepassword/services/changePassword.serviceMock.ts